/* sucrase/dist/esm/util/getDeclarationInfo.js */ function _(require, module, exports, __esModule, __esExport) {
    __esModule();
    exports.default = getDeclarationInfo;
    const tokenizer_1 = require("bfb18d0576") /* ../parser/tokenizer */;
    const types_1 = require("f0c35cbd76") /* ../parser/tokenizer/types */;
    exports.EMPTY_DECLARATION_INFO = {
        typeDeclarations: new Set(),
        valueDeclarations: new Set(),
    };
    /**
     * Get all top-level identifiers that should be preserved when exported in TypeScript.
     *
     * Examples:
     * - If an identifier is declared as `const x`, then `export {x}` should be preserved.
     * - If it's declared as `type x`, then `export {x}` should be removed.
     * - If it's declared as both `const x` and `type x`, then the export should be preserved.
     * - Classes and enums should be preserved (even though they also introduce types).
     * - Imported identifiers should be preserved since we don't have enough information to
     *   rule them out. --isolatedModules disallows re-exports, which catches errors here.
     */
    function getDeclarationInfo(tokens) {
        const typeDeclarations = new Set();
        const valueDeclarations = new Set();
        for (let i = 0; i < tokens.tokens.length; i++) {
            const token = tokens.tokens[i];
            if (token.type === types_1.TokenType.name && (0, tokenizer_1.isTopLevelDeclaration)(token)) {
                if (token.isType) {
                    typeDeclarations.add(tokens.identifierNameForToken(token));
                }
                else {
                    valueDeclarations.add(tokens.identifierNameForToken(token));
                }
            }
        }
        return { typeDeclarations, valueDeclarations };
    }
}
